module.exports = __webpack_public_path__ + "static/media/camurus-logo-webb-bliue-1.b25127dd.jpeg";